const ORDER_EDITORS = new Set([
  "caleb@beveragebrothers.co.nz",
  "bec@beveragebrothers.co.nz",
  "admin@beveragebrothers.co.nz",
]);

export function canEditOrders(email) {
  return ORDER_EDITORS.has(String(email || "").trim().toLowerCase());
}

export function toOrderHistoryEntry(order) {
  if (!order) return null;

  return {
    orderId: order.orderId,
    date: order.date || "",
    total: Number(order.total || 0),
    pick: order.pick ?? null,
    purchaseOrder: order.purchaseOrder || "",
    distribution: order.distribution || "",
    notes: order.notes || "",
    customerId: order.customerId,
    updatedAt: order.updatedAt || null,
    updatedByEmail: order.updatedByEmail || null,
  };
}

export function syncOrderIntoCustomers(customers = [], order) {
  const nextOrder = toOrderHistoryEntry(order);
  if (!nextOrder?.orderId) return customers;

  return customers.map((customer) => {
    const existingHistory = Array.isArray(customer.orderHistory)
      ? customer.orderHistory
      : [];

    const historyWithoutOrder = existingHistory.filter(
      (item) => item.orderId !== nextOrder.orderId
    );

    if (customer.id !== nextOrder.customerId) {
      return {
        ...customer,
        orderHistory: historyWithoutOrder,
      };
    }

    return {
      ...customer,
      orderHistory: [...historyWithoutOrder, nextOrder],
    };
  });
}

export function getOrderActivityTimestamp(order) {
  return order?.date || "";
}
